import axios from 'axios'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { formatDateFit } from '../screens/buyer/BuyerRequestDetails'
import {  convertToLocalDate, ValidateAPI } from '../utils/Utils'
import axiosInstance from '../api/axiosInstance'

const Stepper = ({ status, crId, iscancelled, refresh, requestData }) => {

  const fatUpload = requestData?.request_type?.toLowerCase() === 'upload';

  const firstStep = [
    { suppRes: 'Awaiting Response', updatedAT: '', prefix: "" },
    { suppRes: 'Vendor Responded', updatedAT: '', prefix: "" },
    { suppRes: 'Closed', updatedAT: '', prefix: "CR" }
  ]
  const [steps, setSteps] = useState(firstStep)
  const secondStep = [
    { suppRes: 'Awaiting Response', updatedAT: '', prefix: "" },
    { suppRes: 'Cancelled', updatedAT: '', prefix: "" },
    { suppRes: 'Vendor Responded', updatedAT: '', prefix: "" },
    { suppRes: 'Closed', updatedAT: '', prefix: "CR" }
  ]

  const thirdStep = [
    { suppRes: 'Revision Created', updatedAT: '', prefix: "" },
    {suppRes: 'Cancelled', updatedAT: '', prefix: "" },
    { suppRes: 'Closed', updatedAT: '', prefix: "CR" }
  ]

  const [fatUploadSteps, setFatUploadSteps] = useState(thirdStep)
  const [stepsCancel, setStepsCancel] = useState(secondStep)
  const [loading, setloading] = useState(false)
  // //for canceled and calelled it will sore calcelled value as status bcz in
  // let value = status ==='Canceled'? 'Cancelled':status

  const displayFatUploadSteps =
  status?.toLowerCase() === 'closed'
    ? fatUploadSteps.filter(step => step.suppRes !== 'Cancelled')
    : fatUploadSteps;
    
  const currentStepIndex = fatUpload
  ? displayFatUploadSteps?.findIndex((step) => step.suppRes === status)
   : iscancelled
      ? stepsCancel?.findIndex((item) => item.suppRes === status)
      : steps?.findIndex((item) => item.suppRes === status);
      
  const fetchCommentsData = () => {
    axiosInstance
      .get(`/api/get-all-cr-activity-by-crid?hftcrid=${crId}`)
      .then((response) => {
        const newArray = fatUpload ? [...thirdStep] : iscancelled ? [...secondStep] : [...firstStep]
        const activities = response?.data || [];
        if (fatUpload) {
          newArray[0] = {
            ...newArray[0], updatedAT: response?.data?.find((item) => item?.MESSAGE?.includes('Created'))?.CREATION_DATE || requestData?.CREATION_DATE,
          };

          if (requestData?.status?.toLowerCase() === 'cancelled') {
            const cancelledActivity = activities.find((item) => item?.MESSAGE?.includes('Cancelled'));
            newArray[1] = {
              ...newArray[1],
              updatedAT: cancelledActivity?.CREATION_DATE || requestData?.updated_at,
            };
          }
          if (requestData?.status?.toLowerCase() === 'closed') {
            newArray[2] = {
              ...newArray[2],
              updatedAT:
                response?.data?.find((item) =>
                  item?.MESSAGE?.includes('Closed')
                )?.CREATION_DATE || requestData?.updated_at,
            };
          }

          setFatUploadSteps(newArray);
          setloading(true);
          return;
        }
        else {
          response?.data?.map((item) => {
            if (item?.MESSAGE?.includes('Created'))
              newArray[0] = { ...newArray[0], ...{ updatedAT: item?.CREATION_DATE } }
            else if (
              item?.MESSAGE?.includes('Accepted') ||
              item?.MESSAGE?.includes('Vendor Initiated')
            ) {
              newArray[1] = { ...newArray[1], ...{ updatedAT: item?.CREATION_DATE } }
            } else if (item?.MESSAGE?.includes('Rejected'))
              newArray[2] = { ...newArray[2], ...{ updatedAT: item?.CREATION_DATE } }
            else if (item?.MESSAGE?.includes('Closed'))
              newArray[2] = { ...newArray[2], ...{ updatedAT: item?.CREATION_DATE } }
            else if (item?.MESSAGE?.includes('Cancelled'))
              newArray[1] = { ...newArray[1], ...{ updatedAT: item?.CREATION_DATE } }
            fatUpload ? setFatUploadSteps(newArray) : iscancelled ? setStepsCancel(newArray) : setSteps(newArray)
          })
        }
        setloading(true)
      })
      .catch((error) => {
        console.error(error);
      })
  }
  let start
  useEffect(() => {
    fetchCommentsData()
    //  start = new Date();

  }, [crId, iscancelled, status, refresh])

  return (
    <>
      {
        loading &&
        <div className='w-full flex justify-center items-start relative'>
          <div className='w-[70%] border border-gray-200 absolute top-3' />
          <div className='w-[80%] flex justify-between items-center'>
              {(
                fatUpload
                  ? displayFatUploadSteps
                    : iscancelled
                      ? stepsCancel
                      : steps
              )?.map((step, index) => (<div
                className='flex flex-col z-10 justify-start items-center gap-2 h-[100px]'
                key={index + step}
              >
                <div
                  className={`rounded-full border-2 p-1 ${currentStepIndex >= index
                      ? 'border-blue-600'
                      : 'border-gray-300'
                    } w-6 h-6 flex justify-center items-center `}
                >
                  <div
                    className={`p-1.5 rounded-full ${currentStepIndex >= index ? 'bg-blue-600' : 'bg-gray-300'
                      }`}
                  ></div>
                </div>
                <div
                  className={`${currentStepIndex >= index ? 'text-blue-600' : 'text-gray-400'
                    } text-center text-xs font-medium w-[160px]`}
                >
                  <p>{step?.prefix} {step?.suppRes}</p>
                  <p>{step?.updatedAT && convertToLocalDate(step?.updatedAT)}</p>
                </div>
              </div>
            ))}
          </div>
          {/* <pre>{JSON.stringify(step, null, "\t")}</pre> */}
        </div>

      }
      {/* <pre>{JSON.stringify(steps, null, "\t")}</pre>  */}
    </>
  )
}
export default Stepper